export const rdsNullParamters = ['NOT_APPLIED', '!=NULL', '=NULL'] as const;
export type RdsNullParameter = typeof rdsNullParamters[number];

/** Labels for null parameters, contain html */
export const rdsNullParameterLabels: Record<RdsNullParameter, string> = {
  NOT_APPLIED: 'Not applied',
  '!=NULL': 'Where values are <strong>not</strong> null',
  '=NULL': 'Where values are null',
} as const;

export const rdsNullParameterIcons: Record<RdsNullParameter, string> = {
  NOT_APPLIED: null,
  '!=NULL': 'call_split',
  '=NULL': 'call_merge',
} as const;

export function invertNullOperation(parameter: RdsNullParameter): RdsNullParameter {
  switch (parameter) {
    case 'NOT_APPLIED':
      return 'NOT_APPLIED';
    case '!=NULL':
      return '=NULL';
    case '=NULL':
      return '!=NULL';
  }
}

export class RdsNullParameterOption {
  constructor(public label: string, public type: RdsNullParameter) {}
}

export const RDS_NULL_PARAMETER_OPTIONS: ReadonlyArray<RdsNullParameterOption> = Object.freeze(
  rdsNullParamters.map((paramter) => new RdsNullParameterOption(rdsNullParameterLabels[paramter], paramter))
);

export class RdsNullFilter {
  /**
   * Creates an instance of RdsNullFilter
   * @param parameter RdsNullParameterOption
   */
  constructor(public parameter: RdsNullParameterOption) {}
}

export function instanceOfRdsNullFilter(obj: any): obj is RdsNullFilter {
  return !!obj && 'parameter' in obj && rdsNullParamters.includes(obj.parameter);
}
